/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Shop/ShoppingCart': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M19.933 22.003h.5a.254.254 0 0 0 .25-.222l1.318-7.496A.252.252 0 0 0 21.75 14h-.5a.253.253 0 0 0-.251.22l-1.317 7.498a.253.253 0 0 0 .25.285m-4.423-7.75v7.496c0 .14.113.254.253.254h.494a.254.254 0 0 0 .253-.254v-7.496a.253.253 0 0 0-.253-.253h-.494a.253.253 0 0 0-.253.253M10.756 14h-.5a.254.254 0 0 0-.251.285l1.346 7.497a.253.253 0 0 0 .25.22h.497c.152 0 .27-.133.25-.284l-1.341-7.497a.253.253 0 0 0-.251-.221m12.786 9H8.465l-1.29-11h17.656l-1.289 11zm4.201-13H17.297l-5.63-6.904a.263.263 0 0 0-.369-.037l-1.144.933a.26.26 0 0 0-.037.368L14.716 10H4.257a.254.254 0 0 0-.254.254v.993c0 .002-.003.003-.003.006v.494c0 .14.114.253.253.253H5l1.712 12.782a.257.257 0 0 0 .254.218h18.075a.257.257 0 0 0 .253-.218L27.007 12h.736a.26.26 0 0 0 .26-.26V10.26a.26.26 0 0 0-.26-.26z"/>'
  }
})
